<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-12">
          <div
            class="text-sm text-center copyright text-muted"
          >
            ©
            {{ new Date().getFullYear() }}, made with
            <i class="fa fa-heart"></i> by
            <span class="font-weight-bold">Valora</span>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
